export default "__VITE_ASSET__74zb1BM1__"